//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/payment-type/components/PaymentType.vue
// module id = WlSS
// module chunks = 4